import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { PlanUnitSelectorProps } from '../PlanUnitSelector/PlanUnitSelector';
import PlanUnitSelector from '../PlanUnitSelector/PlanUnitSelector';

type Props<T, U> = Omit<PlanUnitSelectorProps<T, U>, 'onSelected'> & {
  control: Control<any>;
  name: string;
  variant?: 'standard' | 'outlined' | 'filled';
  size?: 'small' | 'medium';
  shouldDisableDate?: (date: Date) => boolean;
};

export default function ControlledPlanUnitSelector<
  T extends boolean,
  U extends boolean
>({
  control,
  name,
  variant,
  size = 'small',
  ...planUnitSelectorProps
}: Props<T, U>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <PlanUnitSelector
            {...field}
            {...{ ref: undefined }}
            {...planUnitSelectorProps}
            defaultValue={field.value ? [field.value] : undefined}
            error={!!fieldState?.error?.type}
            helperText={fieldState?.error?.message}
            variant={variant}
            size={size}
            onSelected={(options) =>
              options.length > 0
                ? field.onChange(options[0])
                : field.onChange(null)
            }
          />
        );
      }}
    />
  );
}
